import { render, staticRenderFns } from "./BillPayersList.vue?vue&type=template&id=5a5ca00a&scoped=true"
import script from "./BillPayersList.vue?vue&type=script&lang=js"
export * from "./BillPayersList.vue?vue&type=script&lang=js"
import style0 from "./BillPayersList.vue?vue&type=style&index=0&id=5a5ca00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ca00a",
  null
  
)

export default component.exports